var exports = {
  "u": "x93eb46d8--2e0f8b--section",
};

module.exports = exports;
